import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { Link } from 'react-router-dom';
import { StyledTableRow } from '../../../commun/table-row';
import { PaymentScheduleDto } from '../../../../services/dtos/payment-schedule.dto';
import { ArrowBack } from '@mui/icons-material';
import React from 'react';

/**
 * Composant du tableau des pages
 * @param props Pages à afficher
 * @constructor
 */
export default function PaymentScheduleUi(props: { paymentSchedule?: Array<PaymentScheduleDto>; id?: string }) {
    // En-têtes des cellules du tableau
    const headCells = [
        {
            id: 'date',
            label: 'Date',
            sort: false,
        },
        {
            id: 'montant',
            label: 'Montant(€)',
            sort: false,
        },
        {
            id: 'type',
            label: 'Type',
            sort: false,
        },
    ];

    return (
        <TableContainer className={'containerPaymentSchedule'} component={Paper} sx={{ padding: '20px' }}>
            {/*Affichage le titre */}
            <Typography variant={'h5'}>
                <Tooltip title={'Retourner au contrat'}>
                    <IconButton component={Link} to={'/contrat/' + props.id}>
                        <ArrowBack></ArrowBack>
                    </IconButton>
                </Tooltip>
                Mon échéancier
            </Typography>

            {/*// Affichage du tableau*/}
            <Table>
                <TableHead>
                    <TableRow>
                        {/*En-têtes*/}
                        {headCells.map(headCell => (
                            <TableCell key={headCell.id} align={'left'} sx={{ fontWeight: 'bold', fontSize: 'medium' }}>
                                {headCell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {/* Gestion du chargement des pages/tri avec une progress bar */}
                <TableBody>
                    {props.paymentSchedule ? (
                        // Lignes du tableau
                        props.paymentSchedule?.map(row => (
                            <StyledTableRow key={row.date}>
                                {/* Remise de la date au bon format */}
                                <TableCell>{new Date(row.date).toLocaleDateString()}</TableCell>
                                <TableCell>{row.montant}</TableCell>
                                <TableCell>{row['@type']}</TableCell>
                            </StyledTableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={headCells.length}>
                                <LinearProgress />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
